export function composeAnalytics(events) {
  return {
    events
  };
}

export function composeEvent(name, payload) {
  return {
    event: name,
    payload
  };
}

export default {
  composeAnalytics,
  composeEvent
};
